import { CSSTransition, TransitionGroup } from "react-transition-group";
import React, { useState } from "react";

import BlogGridItem from "./BlogGridItem";
import BlogListFilters from "./BlogListFilters";
import Box from "./Box";
import BoxWithGutter from "./BoxWithGutter";
import Grid from "./Grid";
import PropTypes from "prop-types";

function BlogListGrid({ pages }) {
  const [currentCategory, setCurrentCategory] = useState(null);
  const categories = [
    ...new Set(
      pages.map((page) => {
        return page.category;
      })
    ),
  ];

  const gridItems = currentCategory
    ? pages.filter((page) => {
        return page.category === currentCategory;
      })
    : pages;

  return (
    <BoxWithGutter pt={[30, null, 60, null]} pb={[80, null, 130, null]}>
      <Box pb={[30, null, 50, null]}>
        <BlogListFilters
          categories={categories}
          current={currentCategory}
          setCurrent={setCurrentCategory}
        />
      </Box>
      <TransitionGroup className="blog-list">
        {gridItems.map((page) => {
          return (
            <CSSTransition
              key={`${page.slug}-${currentCategory}`}
              timeout={300}
              classNames="transition-item"
            >
              <BlogGridItem key={page.slug} {...page} />
            </CSSTransition>
          );
        })}
      </TransitionGroup>
    </BoxWithGutter>
  );
}

export default BlogListGrid;

BlogListGrid.propTypes = {
  pages: PropTypes.arrayOf(PropTypes.object),
};
